export default "__VITE_ASSET__D13PVJQD__"